import './loader-styles.css'

export const Spinner: React.FC<{type: 'small' | 'medium' | 'large'}> = ({type}) => {
    return <div className={`spinner-loader ${type}`}></div>
}